import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { HomePage } from './pages/HomePage';
import { OnboardingPage } from './pages/OnboardingPage';
import { ChatbotPage } from './pages/ChatbotPage';
import { StoriesPage } from './pages/StoriesPage';
import { QuizzesPage } from './pages/QuizzesPage';
import { ToolboxPage } from './pages/ToolboxPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { ProfilePage } from './pages/ProfilePage';
import { EmotionalIntelligencePage } from './pages/EmotionalIntelligencePage';
import { BodyPositivityPage } from './pages/BodyPositivityPage';
import { PeerRelationshipsPage } from './pages/PeerRelationshipsPage';
import { CommunicationSkillsPage } from './pages/CommunicationSkillsPage';
import { OnlineSafetyPage } from './pages/OnlineSafetyPage';
import { MythBustersPage } from './pages/MythBustersPage';
import { ProgressProvider, useProgress } from './context/ProgressContext';
import { EmergencyHelpButton } from './components/EmergencyHelpButton';
import { Navigation } from './components/Navigation';
function ProtectedRoutes() {
  const {
    progress
  } = useProgress();
  if (!progress.preferences.hasCompletedOnboarding) {
    return <Navigate to="/welcome" replace data-id="element-0" />;
  }
  return <>
      <EmergencyHelpButton data-id="element-1" />
      <Navigation data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/home" element={<HomePage data-id="element-5" />} data-id="element-4" />
        <Route path="/chatbot" element={<ChatbotPage data-id="element-7" />} data-id="element-6" />
        <Route path="/stories" element={<StoriesPage data-id="element-9" />} data-id="element-8" />
        <Route path="/quizzes" element={<QuizzesPage data-id="element-11" />} data-id="element-10" />
        <Route path="/myth-busters" element={<MythBustersPage data-id="element-13" />} data-id="element-12" />
        <Route path="/toolbox" element={<ToolboxPage data-id="element-15" />} data-id="element-14" />
        <Route path="/resources" element={<ResourcesPage data-id="element-17" />} data-id="element-16" />
        <Route path="/profile" element={<ProfilePage data-id="element-19" />} data-id="element-18" />
        <Route path="/emotional-intelligence" element={<EmotionalIntelligencePage data-id="element-21" />} data-id="element-20" />
        <Route path="/body-positivity" element={<BodyPositivityPage data-id="element-23" />} data-id="element-22" />
        <Route path="/peer-relationships" element={<PeerRelationshipsPage data-id="element-25" />} data-id="element-24" />
        <Route path="/communication" element={<CommunicationSkillsPage data-id="element-27" />} data-id="element-26" />
        <Route path="/online-safety" element={<OnlineSafetyPage data-id="element-29" />} data-id="element-28" />
        <Route path="*" element={<Navigate to="/home" replace data-id="element-31" />} data-id="element-30" />
      </Routes>
    </>;
}
function ThemeWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    progress
  } = useProgress();
  useEffect(() => {
    if (progress.preferences.theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [progress.preferences.theme]);
  return <>{children}</>;
}
export function App() {
  return <ProgressProvider data-id="element-32">
      <ThemeWrapper data-id="element-33">
        <BrowserRouter data-id="element-34">
          <Routes data-id="element-35">
            <Route path="/" element={<LandingPage data-id="element-37" />} data-id="element-36" />
            <Route path="/welcome" element={<OnboardingPage data-id="element-39" />} data-id="element-38" />
            <Route path="/*" element={<ProtectedRoutes data-id="element-41" />} data-id="element-40" />
          </Routes>
        </BrowserRouter>
      </ThemeWrapper>
    </ProgressProvider>;
}